import { Autocomplete, Box, Grid, Stack, TextField, Typography } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";

import PricingReportProductFilter from "./PricingReportProductFilter";
import PricingReportRetailerFilter from "./PricingReportRetailerFilter";

const PricingReportFilters = ({
  dateFrom,
  dateTo,
  setDateFrom,
  setDateTo,
  provinceChoices,
  selectedProvince,
  setSelectedProvince,
  productFilterChoices,
  selectedProducts,
  setSelectedProducts,
  retailerChoices,
  selectedRetailers,
  setSelectedRetailers,
  providerChoices,
  selectedProvidersInclude,
  setSelectedProvidersInclude,
  isLoadingFilterOptions,
  isPublishedProductsLoading,
  isRetailerFilterCountsLoading = false,
  formatProductOptionLabel,
  formatProviderOptionLabel,
  filterActions,
  title = "Pricing Report",
  description = "Filter national price history by date range, products, province, retailer, and provider.",
  extraFilters = null,
}) => {
  return (
    <Box>
      <Typography className="form-section-title" variant="h4" component="h4">
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, mb: 2 }}>
        {description}
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <DatePicker
            label="From"
            value={dateFrom}
            onChange={setDateFrom}
            slotProps={{ textField: { fullWidth: true, size: "small" } }}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={3}>
          <DatePicker
            label="To"
            value={dateTo}
            onChange={setDateTo}
            slotProps={{ textField: { fullWidth: true, size: "small" } }}
          />
        </Grid>

        <Grid item xs={12} sm={12} md={8} lg={6}>
          <PricingReportProductFilter
            options={productFilterChoices}
            value={selectedProducts}
            onChange={setSelectedProducts}
            formatOptionLabel={formatProductOptionLabel}
            loading={isPublishedProductsLoading}
          />
        </Grid>
      </Grid>

      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <Autocomplete
            fullWidth
            size="small"
            options={provinceChoices}
            value={selectedProvince}
            onChange={(_, nextProvince) => setSelectedProvince(nextProvince)}
            getOptionLabel={(option) => option?.label ?? ""}
            isOptionEqualToValue={(a, b) => a?.value === b?.value}
            renderInput={(params) => <TextField {...params} label="Province" />}
            loading={isLoadingFilterOptions}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={3}>
          <PricingReportRetailerFilter
            options={retailerChoices}
            value={selectedRetailers}
            onChange={setSelectedRetailers}
            loading={isLoadingFilterOptions || isRetailerFilterCountsLoading}
          />
        </Grid>

        <Grid item xs={12} sm={12} md={8} lg={6}>
          <Autocomplete
            fullWidth
            multiple
            size="small"
            options={providerChoices}
            value={selectedProvidersInclude}
            onChange={(_, nextProviders) => setSelectedProvidersInclude(nextProviders)}
            getOptionLabel={(provider) => formatProviderOptionLabel(provider)}
            renderInput={(params) => <TextField {...params} label="Include Providers" />}
            loading={isLoadingFilterOptions}
          />
        </Grid>
      </Grid>

      {extraFilters}

      {filterActions ? (
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={1}
          alignItems={{ xs: "stretch", sm: "center" }}
          flexWrap="wrap"
          useFlexGap
          sx={{
            mt: 2,
            "& .MuiButton-root": { width: { xs: "100%", sm: "auto" } },
          }}
        >
          {filterActions}
        </Stack>
      ) : null}
    </Box>
  );
};

export default PricingReportFilters;
